import { useState, useCallback } from "react";

const APP_SYSTEM_TRACK_ENDPOINT = process.env.REACT_APP_GET_APP_SYSTEM_TRACK;
const APIKEY = process.env.REACT_APP_APIKEY;

const useFetchAppSystemTrack = () => {
    const [systemTrackData, setAppSystemTracking] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [orderTrackingInfo, setOrderTracking] = useState(null);

    const fetchSystemTrackInfo = useCallback(async (bookingNumber, partyCustomerNumber, systemName) => {

        const url = new URL(`${APP_SYSTEM_TRACK_ENDPOINT}track?`);
        const params = { BookingNumber: bookingNumber, partyCustNnumber: partyCustomerNumber };
        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));

        setLoading(true);
        setError(null);

        try {
            const response = await fetch(url.toString(), {
                headers: {
                    "x-api-key": APIKEY,
                    "systemName": systemName,
                },
                method: "GET",
            });
            if (response.ok) {
                const data = await response.json();
                console.log("system data after api call", data);
                setAppSystemTracking(data);
                return data;  // Ensure data is returned
            } else {
                throw new Error("Could not fetch app-system tracking");
            }
        } catch (error) {
            setError(error.message);
            return null;  // Ensure error is handled
        } finally {
            setLoading(false);
        }
    }, []);
 
    const fetchOrderInfo = useCallback(async (orderNumber, orderSourceType, customerName) => {
        const url = new URL(`${APP_SYSTEM_TRACK_ENDPOINT}track?`);
        const params = { OrderNumber: orderNumber, OrderSourceType: orderSourceType, CustomerName: customerName };
        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));

        setLoading(true);
        setError(null);

        try {
            const response = await fetch(url.toString(), {
                headers: {
                    "x-api-key": APIKEY,
                    "systemName":'SOFTEON',
                },
                method: "GET",
            });
            if (response.ok) {
                const data = await response.json();
                console.log("order data after api call", data);
                setOrderTracking(data);
                return data;  // Ensure data is returned
            } else {
                throw new Error("Could not fetch order tracking");
            }
        } catch (error) {
            setError(error.message);
            return null;  // Ensure error is handled
        } finally {
            setLoading(false);
        }

    }, []);

    return { systemTrackData, loading, error, fetchSystemTrackInfo, orderTrackingInfo ,fetchOrderInfo};


};

export default useFetchAppSystemTrack;
